import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-12v2',
  templateUrl: './12v2.component.html',
})
export class VbGeneral12v2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
